import styled from 'styled-components'
import SelectList from 'ui/src/components/controls/select-list'
import { CONTROL_SPACING } from '../../constants'

export const Input = styled.div`
    display: flex;
    gap: ${CONTROL_SPACING}px;
    margin-bottom: 15px;
`

export const Pills = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${CONTROL_SPACING}px;
`

export const LabelSelectList = styled(SelectList)`
    max-height: 300px;
    overflow: auto;
    padding: 0;
    width: 100%;
`

export const Message = styled.p<{ $error?: boolean }>`
    color: ${({ $error }) => ($error ? '#ff6666' : 'inherit')};
    font-size: 13px;
    margin: 8px 0 0;
    opacity: ${({ $error }) => ($error ? 1 : 0.7)};
`
